module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "BEPI",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("“We rejoice in our sufferings,")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "BEPI2"
  }, [_vm._v("knowing that suffering produces")]), _vm._v(" "), _c('p', {
    staticClass: "BEPI2"
  }, [_vm._v("endurance, endurance produces")]), _vm._v(" "), _c('p', {
    staticClass: "BEPI2"
  }, [_vm._v("character, and character produces")]), _vm._v(" "), _c('p', {
    staticClass: "BEPI2"
  }, [_vm._v("hope. And hope does not")]), _vm._v(" "), _c('p', {
    staticClass: "BEPI2"
  }, [_vm._v("disappoint us.”")]), _vm._v(" "), _c('p', {
    staticClass: "BEPIC"
  }, [_vm._v("Romans 5:3–5")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e1aff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epi.vue
// module id = 72
// module chunks = 0